var YBRequest = require('../../../request')
var Parser = require('./parser')
var TransportFormat = require('../../../../constants/transportFormat')
const { AnalyticsTag } = require('../../../../../common/Constants');
const { default: Log } = require('../../../../../common/log');

var HlsParser = Parser.extend(
  /** @lends npaw.HlsParser.prototype */
  {
    /**
     * Starts the HLS parsing from the given resource. The first (outside) call should set the
     * parentResource to null.
     *
     * @param {string} resource Either the resource url or the manifest body.
     * @param {string} parentResource Parent resource in case relative paths are sent.
     */
    parse: function (resource, lastManifest, parentResource) {
      parentResource = parentResource || ''
      var matches = null
      try {
        // First try to find video streams (EXT-X-STREAM-INF lines followed by URLs)
        var videoStreamMatch = this._findVideoStreamUrl(resource)
        if (videoStreamMatch) {
          matches = videoStreamMatch
        } else {
          // Prepare resource for parsing
          var preparedResource = resource.replaceAll(',URI=', '\n').replaceAll('"', '').replaceAll(',', '\n')
          if (this._parseLastChunk) {
            // Find ALL matching chunks and take the last one
            var allMatches = []
            var videoRegex = /((\S*?)(\.m3u8|\.m3u|\.ts|\.m4s|\.mp4|\.cmfv|\.fmp4)((\?|;)\S*|\n|\r|$))/gi
            var match
            while ((match = videoRegex.exec(preparedResource)) !== null) {
              allMatches.push(match)
            }
            if (allMatches.length > 0) {
              // Get the last match
              matches = allMatches[allMatches.length - 1]
            } else {
              // If no video chunks found, look for audio chunks
              var audioRegex = /((\S*?)(\.m4a|\.aac|\.mp3|\.ac3|\.ec3)((\?|;)\S*|\n|\r|$))/gi
              allMatches = []
              while ((match = audioRegex.exec(preparedResource)) !== null) {
                allMatches.push(match)
              }
              if (allMatches.length > 0) {
                matches = allMatches[allMatches.length - 1]
              }
            }
          } else {
            // Original behavior - get first match
            // Step 1: Prioritize video chunks and manifests
            matches = /((\S*?)(\.m3u8|\.m3u|\.ts|\.m4s|\.mp4|\.cmfv|\.fmp4)((\?|;)\S*|\n|\r|$))/i.exec(preparedResource)
            // Step 2: If no video chunks found, look for audio chunks only
            if (!matches) {
              matches = /((\S*?)(\.m4a|\.aac|\.mp3|\.ac3|\.ec3)((\?|;)\S*|\n|\r|$))/i.exec(preparedResource)
            }
          }
        }
      } catch (err) {
        Log.warn(AnalyticsTag, 'Parse HLS Regex failed', err)
        this.done()
      }

      if (matches !== null) { // get first line ending in .m3u8, .m3u, .mp4, .cmfv or .ts
        var res = matches[1].trim()
        var prevParent = ''
        var index = parentResource.lastIndexOf('/')
        if (res.indexOf('http') !== 0 && index !== -1) {
          // If does not start with http, add parentResource relative route.
          if (res[0] === '/' && res[1] !== '/') {
            // if its a relative route not using the same path, but the same domain
            var ind = parentResource.indexOf('/') + 1
            ind += parentResource.substr(ind, parentResource.length).indexOf('/') + 1 // Second '/'
            ind += parentResource.substr(ind, parentResource.length).indexOf('/') // Third '/'
            res = parentResource.slice(0, ind) + res
          } else {
            // if its sharing the (omitted) path
            res = parentResource.slice(0, index) + '/' + res
          }
          prevParent = parentResource.slice(0, index) + '/'
        }

        if (matches[3] === '.m3u8' || matches[3] === '.m3u') { // It is m3u8 or m3u...
          if (!lastManifest) {
            var request = new YBRequest(res, null, null, { cache: true, requestHeaders: this._headers })

            request.on(YBRequest.Event.SUCCESS, function (resp) {
              this._parseWithManifest(resp, prevParent, matches)
            }.bind(this))

            request.on(YBRequest.Event.ERROR, function (resp) {
              this.done()
            }.bind(this))

            request.send()
          } else {
            this._parseWithManifest(lastManifest, prevParent, matches)
          }
        } else { // It is a media chunk (video or audio)...
          switch (matches[3]) {
            case '.mp4':
            case '.m4s':
            case '.fmp4':
              // Video chunks are also MP4
              this._transportFormat = TransportFormat.MP4
              break
            case '.m4a':
            case '.aac':
            case '.mp3':
            case '.ac3':
            case '.ec3':
              // Audio chunks are also MP4
              this._transportFormat = TransportFormat.MP4
              break
            case '.ts':
              this._transportFormat = TransportFormat.MPEG2
              break
            case '.cmfv':
              this._transportFormat = TransportFormat.CMF
          }
          this._realResource = res
          this.done()
        }
      } else {
        this.done()
      }
    },

    _parseWithManifest: function (resp, prevParent, matches) {
      this._lastManifest = resp
      this.parse(resp.getResponseText(), null, prevParent + matches[2])
    },

    shouldExecute: function (lastManifest) {
      var ret = true
      if (lastManifest) {
        var response = lastManifest.getResponseText()
        ret = response.indexOf('#EXTM3U') !== -1
      }
      return ret
    },

    _findVideoStreamUrl: function (resource) {
      // Check if this looks like an HLS manifest
      if (resource.indexOf('#EXTM3U') === -1) {
        return null
      }
      var lines = resource.split('\n')
      // Look for EXT-X-STREAM-INF lines (video streams) and get the URL from the next line
      for (var i = 0; i < lines.length - 1; i++) {
        var line = lines[i].trim()
        // Skip audio-only streams by checking for AUDIO= without VIDEO= or RESOLUTION=
        if (line.indexOf('#EXT-X-STREAM-INF:') === 0) {
          // This is a video stream if it has RESOLUTION or doesn't specify it's audio-only
          var hasResolution = line.indexOf('RESOLUTION=') !== -1
          var hasVideoCodec = line.indexOf('avc1.') !== -1 || line.indexOf('hev1.') !== -1 || line.indexOf('hvc1.') !== -1
          // Consider this a video stream if it has resolution or video codecs
          if (hasResolution || hasVideoCodec) {
            var nextLine = lines[i + 1].trim()
            var urlMatch = /((\S*?)(\.m3u8|\.m3u)((\?|;)\S*|$))/i.exec(nextLine)
            if (urlMatch) {
              return urlMatch
            }
          }
        }
      }
      return null
    }
  }
)

module.exports = HlsParser
